export interface Activite {
  id: string;
  dateDebut: Date;
  dateFin: Date;
  type: TypeActivite;
}

export enum TypeActivite {
  Ot = 'ot',
  Interne = 'interne',
  Indispo = 'indispo', //travaillées, non-travaillées, immédiates
  Deplacement = 'deplacement',
  Astreinte = 'astreinte',
  Absence = 'Absence',
  CrPartiel = 'CrPartiel',
}
